import React from 'react';
import * as S from './style';

const CollapsibleComponent = ({ idn, heading, subHeader = <></>, onCollapsedClick, infoText = null, persuasion=null, childComponent }) => {

    return (
        <S.Card id={`${idn}Block`}>
            <S.HeaderInput type="checkbox" id={idn}></S.HeaderInput>
            <S.TabLabel htmlFor={idn} onClick={onCollapsedClick} infoText={infoText}>
                <span>{heading}</span>
                {subHeader ? subHeader : <></>}
            </S.TabLabel>
            {persuasion && persuasion?.text ? <S.Persuasion className={persuasion?.className}>{persuasion?.text} </S.Persuasion> : <></>}
            {infoText && infoText?.text ? <S.Info className={infoText?.className}>{infoText?.text} </S.Info> : <></>}
            {childComponent ? <S.TabContent>{childComponent}</S.TabContent> : <></>}
        </S.Card>
    );
};

export default CollapsibleComponent;
